export enum SpinnerSize {
  XXS = 'xxs',
  XS = 'xs',
  S = 's',
  M = 'm',
  L = 'l',
  XL = 'xl',
  XXL = 'xxl',
}

export enum SpinnerColor {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  TextPrimary = 'text-primary',
  TextSecondary = 'text-secondary',
  TextTertiary = 'text-tertiary',
  White = 'white',
  Black = 'black',
}
